function getSearchPlaceholderByLang() {
    var lang = (document.documentElement.lang || 'lt').toLowerCase().split('-')[0];

    var texts = {
        lt: 'Ieškoti',
        en: 'Search',
    };

    return texts[lang] || texts.lt;
}

$(document).on('select2:open', function () {
    setTimeout(function () {
        $('.select2-search__field').attr('placeholder', getSearchPlaceholderByLang());
    }, 0);
});
